<template>
    <div style="width: 100%" class="container pt-6">
        <my-form ref="form" v-if="ready">
            <v-alert dismissible type="info">{{$t('Download ')}} <a :href="getSrc('tax.pdf')" target="_blank" class="white--text">{{$t('tax form')}}</a></v-alert>
            <v-card class="mt-5">
                <v-card class="my-shadow">
                    <v-card-title>
                        <div class="w-100 mx-0 row justify-space-between">
                            <div>{{$t("New Tax Form")}}</div>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <div class="w-100 mb-4 subtitle-1">
                            {{$t('Upload new tax form')}}
                        </div>
                        <v-flex>
                            <v-file-input outlined @click:clear="$nextTick(() => newPdf=null)" show-size counter chips multiple label="Upload pdf" :rules="[validationRules.required]" type="file" ref="file" id="file" v-model="newPdf"></v-file-input>
                        </v-flex>

                        <v-layout align-end justify-end>
                            <v-btn
                                :loading="loading"
                                :disabled="loading"
                                color="primary"
                                class="ma-2 white--text"
                                @click="submitFiles"
                            >
                                Upload
                                <v-icon
                                    right
                                    dark
                                >
                                    mdi-cloud-upload
                                </v-icon>
                            </v-btn>
                        </v-layout>


                    </v-card-text>
                </v-card>

            </v-card>

            <v-card class="mt-5">
                <v-card-title>{{$t("Uploaded tax forms")}}</v-card-title>
                <v-data-table
                    :headers="headers"
                    :items="taxPdf"
                >
                    <template v-slot:item.name="{item}">
                        {{item.name}}
                    </template>
                    <template v-slot:item.delete="{item}">
                        <v-btn style="width: 26px; height: 26px;" fab dark color="red" @click="deletePdf(item.name)"><v-icon width="13px" height="13px" style="font-size: 13px;">mdi-trash-can</v-icon></v-btn>
                    </template>
                </v-data-table>
            </v-card>
        </my-form>
    </div>
</template>
<script>
import UploadImage from 'vue-upload-image';
import {getUserTaxPdf, uploadUserTaxPdf, deleteUserTaxPdf} from "../../api/upload";
import {required} from "../../validations";
import AddressComponent from '../../components/fields/address-model';
import {editBread, storeBread} from "@/api/bread";

export default {
    components:{UploadImage, AddressComponent},
    data(){
        return{
            ready:false,
            errors:[],
            headers: [{
                text: 'Name',
                value: 'name',
                sortablae: true,
                align: 'center'
            },
                {
                    text: 'Delete',
                    value: 'delete',
                    sortable: false,
                    align: 'center'
                },
            ],
            taxPdf: [],
            newPdf:null,
            loader: null,
            loading: false,
            test: '0'
        }
    },
    computed:{
        user(){
            return this.$store.getters.user;
        }
    },
    mounted(){
        this.getData();
        this.$store.commit('app/SET_BOTTOM', {
            buttons:[

            ]
        });
    },
    methods:{
        getData(){
            getUserTaxPdf().then(res => {
                this.taxPdf = res;
                this.ready = true;
            })
        },
        submitFiles(){
            if(this.$refs.form.my_validate()){
                if (this.newPdf) {
                    this.loader = true;
                    this.loading = true;
                    let formData = new FormData();
                    let canSendFile = true;
                    // files
                    for (let file of this.newPdf) {
                        this.taxPdf.forEach((tax)=>{
                            if(tax.name === file.name){
                                canSendFile=false;
                                this.$store.commit('app/ADD_MESSAGE', {text: 'Tax form filename is already in use. Change filename if you want to store it.', type: 'error'});
                            }
                        })
                        if(canSendFile){
                            var name = file.name.split(".");
                            if(name[name.length-1] === 'pdf'){
                                formData.append("files", file, file.name);
                                uploadUserTaxPdf(formData).then(() => {
                                    this.getData();
                                    this.loader = false;
                                    this.loading = false;
                                    this.$store.commit('app/ADD_MESSAGE', {text: 'Tax form successfully uploaded.', type: 'success'});
                                }).catch(e => {
                                    this.$store.commit('app/ADD_MESSAGE', {text: e, type: 'error'});
                                })
                            } else {
                                this.$store.commit('app/ADD_MESSAGE', {text: 'Please upload file in pdf extension.', type: 'error'});
                            }
                            this.newPdf = null;
                        } else {
                            this.loader = false;
                            this.loading = false;
                        }
                    }
                    this.loader = false;
                    this.loading = false;
                } else {
                    this.loader = false;
                    this.loading = false;
                    this.$store.commit('app/ADD_MESSAGE', {text: 'File is required.', type: 'error'});
                }
            }
        },
        deletePdf(filename){
            deleteUserTaxPdf({'filename':filename}).then(() => {
               this.getData();
               this.$store.commit('app/ADD_MESSAGE', {text: 'Tax form successfully deleted.', type: 'success'});
            }).catch(e => {
               this.$store.commit('app/ADD_MESSAGE', {text: e, type: 'error'});
            })
        }
    },
}
</script>
